import '../styles/PageGlobal.css';
import './DashboardMaintenancePage.css';
import React from "react";



export default function DashboardMaintenancePage() {
 

  return (
    <div  className="containerMain">
  <h1>Maintenance dashboard</h1>
  <p>Ceci est un contenu protégé</p>

  
</div>
  );
}